import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FORM_STATUS_LABELS, FORM_STATUSES } from "../../../util/constants";
import { selectCurrentFormDataStatus } from "../../../services/form/slices";
import { capitalize } from "../../../util/functions";

function useFormStatus() {
  const { type, id } = useParams();
  const formStatus = useSelector((state) => {
    if (!id) {
      return FORM_STATUSES.UNSAVED;
    }
    return selectCurrentFormDataStatus(state, type, id);
  });
  const formStatusLabel = FORM_STATUS_LABELS[formStatus] || capitalize(formStatus) || "-";

  return {
    key: formStatus,
    label: formStatusLabel
  };
}

export default useFormStatus;
